<template>
  <div ref="mychart" :style="{ height: height, width: width }" style="background: #ffffff00;"></div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  name: "QuanyuChart",
  props: {
      width: {
          type: String,
          default: '430px'
      },
      height: {
          type: String,
          default: '218px'
      },
      dataList:{
          type: Array,
          default: () => []
      }
  },
  data() {
      return {
          chart: null
      }
  },
  watch: {
      dataList(){
          this.initChart()
      }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.mychart);
      this.chart.setOption({
        grid:{
          top: 30, right: 30, bottom: 50, left: 50,
        },
        xAxis: {
          type: 'category',
          data: this.dataList.map(obj => (obj.name)),
          // axisLine: {
          //   show: false
          // },
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 0,
            color: '#fff',
            fontSize: 10,
            lineHeight: 13,
            align: 'center',
            formatter: function (value) {
              return value.length > 3  ? value.replace(/(.{3})/g, '$1\n').trim() : value;
            },
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#fff',
            fontSize: 12,
            formatter: function (value) {
              if (value % 1 === 0) {
                return value;
              }
              return '';
            }
          },
          splitLine: {
            lineStyle: {
              color: ['rgba(51, 161, 218, 0.15)'],
              type: 'dashed'
            }
          }
        },
        series: [
          {
            data: this.dataList.map(obj => (obj.num)),
            type: 'bar',
            barWidth: '12px',
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(22,43,134,0.29)'
            },
            label: {
              show: true,
              position: 'top',
              color: '#fff'
            },
            itemStyle: {
              //borderRadius: [5, 5, 0, 0],
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#1DBEF4' },
                { offset: 0.4, color: '#1DBEF4' },
                { offset: 1, color: '#1D84E3' }
              ])
            },
          }
        ]
      })
    },
  },
}
</script>
<style scoped></style>